import type { VoidFunctionComponent } from 'react';

import { trimString } from '../../../../utils';
import { IconButton } from '../../../generic';
import Flex from '../../../generic/Flex';
import Icon, { icons } from '../../../generic/Icon';
import Link from '../../../generic/Link';

const DEFAULT_MAX_TITLE_LENGTH = 46;

type ItemizedRuleProps = {
  link?: string;
  id: string;
  title?: string;
  removeRule: () => void;
  maxTitleLength?: number;
};

const ItemizedRule: VoidFunctionComponent<ItemizedRuleProps> = ({
  link,
  id,
  title,
  removeRule,
  maxTitleLength = DEFAULT_MAX_TITLE_LENGTH,
}) => {
  const trimmedTitle = trimString(title || '', maxTitleLength);

  const lineItem = trimmedTitle.length ? `${id}: ${trimmedTitle}` : id;

  let content = <div>{lineItem}&nbsp;</div>;
  if (link) {
    content = (
      <Link
        className="itemized-link"
        style={{ cursor: 'pointer', fontSize: '13px', flexGrow: 6, textDecoration: 'none' }}
        to={link}
        openInNewTab>
        {lineItem}&nbsp;
        <span><Icon icon={icons.externalLink} /></span>
      </Link>);
  }

  return (
    <Flex justify="space-between" align="center">
      {content}
      <IconButton onClick={removeRule} icon={icons.minus} />
    </Flex>
  );
};

export default ItemizedRule;
